import { Injectable } from '@angular/core';
// import { JobHome } from './home';
// import { JOBHOME,COURSEINFO } from '../../mock-data';  //mock数据  jobHome
import { CInfo } from '../../shared/models/cou-employ';

import { CusHttp } from '../../core/services/CusHttp';

// 定义接口
// 岗位列表接口 实习就业首页岗位搜索接口

const joblist = 'v1/position/search';
//热门咨询

const NEWINFOLIST = 'v1/consult/hotconsult';
// 根据学生id获取相似的岗位接口
const GETSIMILAR = 'v1/position-keyword/updates';

@Injectable()

export class HomeService {

  constructor(
    public _http: CusHttp,
  ) { }

  getjobListData(str?: string) {
    let url = joblist + `?${str ? str : ''}`;
    return this._http.get(url);
  }
  //获取热门资讯
  getHotInfoList() {
    return this._http.get(NEWINFOLIST);
  }
  // 根据学生id获取相似的岗位接口
  // const GETSIMILAR = 'v1/position/similar';
  getSimilar(keywork: any) {
    let params = new URLSearchParams();
    params.append('keyword', keywork);
    let url = GETSIMILAR;
    return this._http.post(url, params.toString());
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/job/home/home.service.ts